import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a977e19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alphabet-bar" }
const _hoisted_2 = ["id", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lettersDisplay(), (letter) => {
      return (_openBlock(), _createElementBlock("nav", { key: letter }, [
        _withDirectives(_createElementVNode("div", {
          id: letter,
          class: _normalizeClass(this.selectLetter(letter)),
          onClick: ($event: any) => (this.activeLetter(0, letter, 1))
        }, _toDisplayString(letter.toUpperCase()), 11, _hoisted_2), [
          [_vShow, letter]
        ])
      ]))
    }), 128))
  ]))
}